import React, { useState } from 'react'
import styles from './styles.module.scss'
import clsx from 'clsx'
import Image from 'next/image'
import useWidth from 'src/hooks/useWidth'

export type FilterProps = {
  keys?: string[]
  itemActive?: string
  setItemActive?: (item: string) => void
  search?: string
  setSearch?: (item: string) => void
}

export const Filter = ({
  keys,
  itemActive,
  setItemActive,
  search,
  setSearch,
}: FilterProps) => {
  const [showSearch, setShowSearch] = useState(false)
  const { getWidth } = useWidth()

  const handleClick = (key: string) => {
    setItemActive(key)
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value)
  }

  const handleCloseSearch = () => {
    setSearch('')
    setItemActive('')
    setShowSearch(false)
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div
          className={clsx(styles.menu, {
            [styles.hideMenu]:
              showSearch && (getWidth > 1024 || getWidth < 768),
          })}
        >
          <div className={styles.lettersBar}>
            <div className={styles.letters}>
              <div
                className={clsx(styles.item, {
                  [styles.itemActive]: showSearch,
                })}
                onClick={() => setShowSearch(!showSearch)}
              >
                <div
                  className={clsx(styles.letter, {
                    [styles.letterActive]: showSearch,
                  })}
                  style={{ width: '17px' }}
                >
                  <Image
                    src='/assets/icons/icon-search-white.svg'
                    width={17}
                    height={17}
                    alt='search icon'
                  />
                </div>
              </div>
              <div
                className={clsx(styles.item, {
                  [styles.itemActive]: '' === itemActive,
                })}
                onClick={() => handleClick('')}
              >
                <div
                  className={clsx(styles.letter, {
                    [styles.letterActive]: '' === itemActive,
                  })}
                >
                  {'#'}
                </div>
              </div>
              {keys?.map((key, index) => (
                <div
                  key={index}
                  className={clsx(styles.item, {
                    [styles.itemActive]: key === itemActive,
                  })}
                  onClick={() => handleClick(key)}
                >
                  <div
                    className={clsx(styles.letter, {
                      [styles.letterActive]: key === itemActive,
                    })}
                  >
                    {key.toUpperCase()}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {showSearch && (
          <div className={styles.inputContainer}>
            <div className={styles.searchIcon}>
              <Image
                src='/assets/icons/icon-search-green.svg'
                width='17'
                height='17'
                alt='search icon'
              />
            </div>
            <input
              type={'text'}
              className={styles.input}
              value={search}
              onChange={handleChange}
              placeholder={'Search glossary terms...'}
            />
            <div className={styles.closeIcon} onClick={handleCloseSearch}>
              <Image
                src='/assets/icons/icon-close-green.svg'
                width='17'
                height='17'
                alt='close icon'
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
